import script from "./BarbershopInquiryView.vue?vue&type=script&setup=true&lang=js"
export * from "./BarbershopInquiryView.vue?vue&type=script&setup=true&lang=js"

import "@/assets/inquiry-form.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__